module.exports = __webpack_public_path__ + "6bfb9d411ef37630e6b6e90bc826b9d2.otf";